import { Box } from "@mui/material";

import type { FC, ReactNode } from "react";

export const TimelinePill: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    component="span"
    sx={{
      borderRadius: "4px",
      backgroundColor: "#666",
      px: 1,
      py: 0.2,
      color: "white",
      fontWeight: "bold",
    }}
  >
    {children}
  </Box>
);
